

    <div class="timezone-clock">
      <figure class="img-container" [ngClass]="{ 'graph-wrap': false }">
        <base-highchart  [configuration]="config" [style]="{width: '100%', height: '100%', display: 'block'}"> </base-highchart>
      </figure>
    </div>

